import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TimerOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"timer_off"}/>
}
